"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducers = void 0;
var redux_1 = require("redux");
var apis_1 = require("../api/apis");
var item_1 = require("./slices/item/item");
var challenge_1 = __importDefault(require("./slices/challenge/challenge"));
var client_1 = require("./slices/client/client");
var console_1 = __importDefault(require("./slices/console"));
var customers_1 = require("./slices/customers/customers");
var economy_1 = require("./slices/economy/economy");
var entry_1 = __importDefault(require("./slices/entry"));
var event_types_1 = require("./slices/event_types/event_types");
var loyalty_1 = require("./slices/loyalty/loyalty");
var main_1 = __importDefault(require("./slices/main"));
var registration_1 = __importDefault(require("./slices/registration"));
var reward_track_1 = require("./slices/reward_track/reward_track");
var user_1 = require("./slices/user/user");
var reducers = (0, redux_1.combineReducers)(__assign({ 
    //TODO add more as needed
    mainState: main_1.default, consoleState: console_1.default, userState: user_1.userReducer, clientState: client_1.clientReducer, entryState: entry_1.default, registrationState: registration_1.default, itemState: item_1.itemReducer, challengeState: challenge_1.default, rewardTrackState: reward_track_1.rewardTrackReducer, economyState: economy_1.economyReducer, customerState: customers_1.customerReducer, loyaltyState: loyalty_1.loyaltyReducer, eventTypeState: event_types_1.eventTypeReducer }, apis_1.apiReducers));
exports.reducers = reducers;
